<template>
	<div class="contentHome">
		<div class="centerPage">
			<tabCommon></tabCommon>
			<div class="right">
				<p class="title">我的关注医师</p>
				<div class="formUserInfo">
					<div class="leftCon ">
						<div class="userList flex" v-for="(obj,index) in doctorList" :key="index">
							<div class="objImg img" :style="'backgroundImage: url('+obj.headImgPath+')'"></div>
							<div class="right">
								<div class="flex ">
									<h2>{{obj.fullName}} {{obj.enName}}</h2>
									<span class="post overFlow">{{obj.technicalTitle}}</span>
<!--                  {{obj}}-->
                  <shortChat :user-id="obj.id" ></shortChat>
									<el-button @click="toDetail(obj.account)">预约</el-button>
								</div>
								<p class="motto">{{obj.supplement.signature}}</p>
								<div>
									<span class="pay" v-if="obj.isOpenAppoint===0">预约即将开启</span>
									<span class="pay" v-else-if="obj.isOpenAppoint===1">{{obj.supplement.initialCharge}}元/{{obj.supplement.initialMinute}}分钟</span>
									<span class="serviceLength">从业{{obj.startWorkDate | workAge}}年</span>
								</div>
							</div>
						</div>
					</div>
					<div class="empty" v-if="doctorList.length==0">
						<img src="../../assets/img/no.png" alt="" width="200">
						<p>这里什么都没有</p>
					</div>
					<el-pagination
							class="pagination"
							background
							prev-text="Prev"
							next-text="Next"
							@size-change="handleSizeChange"
							@current-change="handleSizeChange"
							:current-page="page.current"
							:page-size="page.size"
							layout="prev, pager, next"
							:total="page.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import base from '@/api/common';

export default {
	name: "physician",
	data() {
		return {
			doctorList: [],
			page: {
				current: 1,
				size: 3,
				total: 0
			},

			getFamousDoctorsUrl: base.api.doctor.listConcern,//著名专家链接
			getCondition: {
				userId: '',//当前用户id
				isConcern: true
			},//查询条件
		}
	},
	components: {
		'tabCommon': () => import('./tabCommon'),
    'shortChat': _ => import('../common/shortChat'),
	},
	async mounted() {
	    /*
		let currentUser = await base.utils.getCurrent();//获取当前登录的用户id
		if (currentUser != null) {
			this.getCondition.userId = currentUser.id;
		}*/
		this.getData();
		/*
		let appointSetting = "9,10,11,15,16,17,18,20,21,22#9,10,11,15,16,17,18,20,21,22#9,10,11,15,16,17,18,20,21,22#9,10,11,15,16,17,18,20,21,22#9,10,11,15,16,17,18,20,21,22#16,17,18,20,21,22#";
		let params = {
			consultMode: 1,
			initialMinute: 30,
			initialCharge: 9.9,
			furtherMinute: 30,
			furtherCharge: 99.9,
			appointSetting: appointSetting,
			appointTimeSlot: base.utils.generateAppointTimeSlot(appointSetting)
		}
		return;
		*/
		// this.$ajax.post(base.api.doctor.appointSetting, params)
		//     .then((res) => {
		//         if (res.data.status == 'success') {
		//             console.log(res.data.message)
		//         }
		//     })
	},
	methods: {
		getData() {
			let vm = this;
			this.$ajax.get(vm.getFamousDoctorsUrl.replace("{size}/{page}", vm.page.size + "/" + vm.page.current)).then((res) => {
				if (res.data.status === 'success') {
					vm.doctorList = res.data.rows;
					vm.page.total = res.data.total;
					vm.page.current = res.data.current;
				}
			})
		},
		handleSizeChange(val) {
			this.page.current = val
			this.getData()
		},
		toDetail(account) {
			// this.$router.push({path: '../../doctorDetail/' + account})
      this.$router.push({path: '/' + account})
		}
	},
	filters: {
		workAge: function (date) {
			date = date.substr(0, 4);
			let d = new Date();
			d = d.getFullYear();
			let age = d - date;
			return age;
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/personalCenter.scss";

.userList {
	.right {
		h2 {
			width: 90%;
		}
	}
}
</style>
